import { Trans } from '@lingui/react'
import { useSelector } from 'react-redux'

import { TENANT_BE } from 'shared/consts'
import { type CartControllerSellerGroupV2 } from 'types/api/cart'
import { type IState } from 'types/redux/store'
import { NOTIFICATION_TYPES } from 'views/components/molecules/Notification'
import { NotificationCart } from 'views/components/organisms/Cart/NotificationCart'
import {
  hasCustomerTypeProfessionalWithMarketplaceProductError,
  hasCustomerTypeProfessionalWithMedicineAndMarketplaceProductError,
  hasCustomerTypeProfessionalWithMedicineProductError,
} from 'views/components/organisms/Cart/NotificationOrderDraft/hasOrderDraftError'
import Tenant from 'views/components/utils/Tenant'

interface IProfesionalCustomerNotificationBlock {
  sellerGroup: CartControllerSellerGroupV2
}

const hasAnyProfessionalUserError = (error: string): boolean => {
  return (
    hasCustomerTypeProfessionalWithMarketplaceProductError(error) ||
    hasCustomerTypeProfessionalWithMedicineProductError(error) ||
    hasCustomerTypeProfessionalWithMedicineAndMarketplaceProductError(error)
  )
}

const ProfesionalCustomerNotificationBlock: React.FC<
  IProfesionalCustomerNotificationBlock
> = ({ sellerGroup }) => {
  const error = useSelector((state: IState) => state.cart.error)

  const cartContainsMedicineProducts = (): boolean => {
    return sellerGroup.groupEntries.some(groupEntry =>
      groupEntry.items.some(item => item.isMedicine)
    )
  }

  const cartContainMarketplaceSeller = (): boolean => {
    const { sellerId } = sellerGroup
    const NOW_PREFIX_SELLER_ID = 'now-'
    const IS_SHOP_APOTHEKE_INTERNAL_SELLER = 'shop-apotheke'

    return (
      sellerId !== IS_SHOP_APOTHEKE_INTERNAL_SELLER &&
      !sellerId.startsWith(NOW_PREFIX_SELLER_ID)
    )
  }

  return (
    <>
      {hasAnyProfessionalUserError(error) && cartContainsMedicineProducts() && (
        <Tenant tenant={[TENANT_BE]}>
          {() => (
            <NotificationCart
              type={NOTIFICATION_TYPES.ERROR}
              classNameOverride="a-full-width m-NotificationCart u-padding--bottom"
            >
              <Trans id="cart.notification.error.noMedicineForProfessionalAccount" />
            </NotificationCart>
          )}
        </Tenant>
      )}
      {hasAnyProfessionalUserError(error) && cartContainMarketplaceSeller() && (
        <Tenant tenant={[TENANT_BE]}>
          {() => (
            <NotificationCart
              type={NOTIFICATION_TYPES.ERROR}
              classNameOverride="a-full-width m-NotificationCart u-padding--bottom"
            >
              <Trans id="cart.notification.error.noMarketplaceProductForProfessionalAccount" />
            </NotificationCart>
          )}
        </Tenant>
      )}
    </>
  )
}

export default ProfesionalCustomerNotificationBlock
